// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div:hover svg[data-v-67d27c70]{--transform-scale-x:1.1;--transform-scale-y:1.1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
